import ThumbUp from '@mui/icons-material/ThumbUp';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function ThumbUpIcon(props: FixMe) {
  return <ThumbUp {...props} />;
}

export default ThumbUpIcon;
